import React, { useEffect, useState } from "react";
import { Button, Typography, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, Link } from "react-router-dom";
import "../css/flowchartSummaryModal.css";
import LoadingCustomButton from "./LoadingCustomButton";
import Global from "../utils/global";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import ReactLoading from "react-loading";

const FlowchartSummaryModal = ({
  selectedNodes,
  open,
  close,
  flowchartId,
  disease_id,
}: any) => {
  const [patientInfo, setPatientInfo] = useState({
    name: "",
    age: "",
    city: "null",
  });
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState(Global.cities);
  const navigate = useNavigate();

  const [type, setType]: any = useState();
  const [openS, setOpenS] = useState(false);
  const [message, setMessage]: any = useState();

  const [submited, setSubmitted] = useState(false);

  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleSubmit = async () => {
    if (!patientInfo.name || !patientInfo.age || patientInfo.city === "null") {
      setType("warning");
      setMessage("Please provide all the details.");
      setOpenS(true);
      return;
    }

    if (!selectedNodes || !selectedNodes[0] || !flowchartId || !disease_id) {
      setType("error");
      setMessage("Something went wrong. Please reopen this modal.");
      setOpenS(true);
      return;
    }

    setLoading(true);

    const nodeIds = selectedNodes.map((data: any) => data.id);
    console.log({ nodeIds, flowchartId });

    const data = await Global.httpPost("disease/submit", {
      flowchart_id: flowchartId,
      disease_id,
      nodes_id: nodeIds,
      patient_info: patientInfo,
    });

    console.log(data);
    if (data && !data.isError) {
      if (data.submited) {
        setType("success");
        setMessage("Submitted successfully");
        setOpenS(true);
        setSubmitted(true);
      }
    } else if (data && data.message) {
      setType("error");
      setMessage(data.message);
      setOpenS(true);
    }
    setLoading(false);
  };

  const getCities = async () => {
    const data = await Global.httpGET("static/cities");
    console.log(data);
    if (data) {
      setCities(data);
      Global.cities = data;
    }
  };

  useEffect(() => {
    if (open && Global.token && !Global.cities[0]) getCities();
  }, [open]);

  return (
    <Modal open={open} onClose={close}>
      <div className="flowchart-summary-modal-overlay">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={openS}
          autoHideDuration={6000}
          onClose={() => {
            setOpenS(false);
          }}
          key={"top" + "center"}
        >
          <Alert severity={type}>{message}</Alert>
        </Snackbar>
        <div className="flowchart-summary-modal">
          <div className="summary-header">
            <div style={{ flexDirection: "row", display: "flex" }}>
              <Typography className="header-text">Summary Preview</Typography>
            </div>
            <div className="column-2">
              <IconButton
                aria-label="close"
                style={{ alignSelf: "baseline" }}
                onClick={() => {
                  setOpenS(false);
                  close();
                }}
              >
                <CloseIcon className="close-btn" />
              </IconButton>
            </div>
          </div>
          <div className="body">
            <div>
              <div className="patient_info">
                <input
                  className="name"
                  placeholder="Patient's Name"
                  type="text"
                  name="name"
                  onChange={(event: any) => {
                    // console.log({ id: event.target.value });
                    setPatientInfo({
                      ...patientInfo,
                      name: event.target.value,
                    });
                  }}
                />
                <input
                  className="age"
                  placeholder="Age"
                  name="age"
                  onChange={(event: any) => {
                    // console.log({ name: event.target.value });
                    if(!event.target.value.match(/^[0-9]*$/)){
                      return
                    }
                    setPatientInfo({
                      ...patientInfo,
                      age: event.target.value,
                    });
                  }}
                  value={patientInfo.age}
                  //   value={name}
                />
                <select
                  className="city"
                  placeholder="City"
                  onChange={(event: any) => {
                    // console.log({ name: event.target.value });
                    setPatientInfo({
                      ...patientInfo,
                      city: event.target.value,
                    });
                  }}
                  // onChangeCapture={(e) => console.log(e)}
                  value={patientInfo.city}
                >
                  <option value="null" disabled>
                    City
                  </option>
                  {cities.map((city: any, index) => (
                    <option key={index} value={city.value}>
                      {city.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="summary">
                {selectedNodes.map((data: any, index: number) => (
                  <div className="data-container" key={index}>
                    <div
                      className="label-container"
                      onClick={() => {
                        //   setExpanded(
                        //      expanded === data.id ? false : data.id
                        //   );
                      }}
                    >
                      <span className="icon-container">
                        {/* <Check className="icon" /> */}
                      </span>
                      <span
                        style={{
                          display: "flex",
                          flex: 1,
                          marginLeft: "10px",
                          flexDirection: "column",
                        }}
                      >
                        {data.data.label
                          .split("\\n")
                          .map((ele: string, index: any) => (
                            <Typography className="label" key={index}>
                              {ele}
                            </Typography>
                          ))}
                      </span>
                    </div>
                    {/* {expanded === data.id ? ( */}
                    <div className="description-container">
                    {data.data.description
                                    .split("\\n")
                                    .map((ele: string, index: any) => (
                                       <Typography
                                          className="description"
                                          key={index}
                                       >
                                          {ele}
                                       </Typography>
                                    ))}
                    </div>
                    {/* ) : null} */}
                  </div>
                ))}
              </div>
            </div>
            <div className="footer">
              {loading ? (
                <ReactLoading
                  type="bubbles"
                  height={"30px"}
                  width={"40px"}
                  color="black"
                  // className="loading-prop"
                />
              ) : (
                <div>
                  {submited ? (
                    <LoadingCustomButton
                      sx={{ marginRight: "20px" }}
                      onClick={() => {
                        if (!patientInfo.name || !patientInfo.age) {
                          setType("warning");
                          setMessage("Please provide all the details.");
                          setOpenS(true);
                          return;
                        }
                        navigate("/summaryPDF", {
                          state: {
                            selectedNodes,
                            previousScreen: "diagnose",
                            patientInfo,
                          },
                        });
                      }}
                    >
                      <Typography className="btn-text">
                        {/* <Link
                                 to="/summaryPDF"
                                 // target="_blank"
                                 rel="noreferrer"
                                 // style={{
                                 //    textDecoration: "none",
                                 //    color: "white",
                                 // }}
                                 className="btn-text"
                                 state={{
                                    selectedNodes,
                                    previousScreen: "diagnose",
                                 }}
                              > */}
                        Export to PDF
                        {/* </Link> */}
                      </Typography>
                    </LoadingCustomButton>
                  ) : (
                    <LoadingCustomButton
                      sx={{ marginRight: "20px", width: 100 }}
                      // loading={true}
                      onClick={handleSubmit}
                    >
                      <Typography className="btn-text">Submit</Typography>
                    </LoadingCustomButton>
                  )}
                </div>
              )}
              <div>
                {/* <LoadingCustomButton>
                           <Typography className="btn-text">Copy</Typography>
                        </LoadingCustomButton> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FlowchartSummaryModal;
